<template>
    <div class="rating-stock-quote">
        <!-- 左侧：Logo + 名称 + 价格 -->
        <div class="rating-stock-quote__left">
            <StockLogo :stock-id="stockId" :stock-name="name" />
            <div class="rating-stock-quote__info">
                <div class="rating-stock-quote__name">
                    <span class="rating-stock-quote__market">{{ market }}</span>
                    <span class="rating-stock-quote__symbol">{{ name }}</span>
                </div>
                <PriceChange :price="price" :change="change" :up-down-color="upDownColor" />
            </div>
        </div>

        <!-- 右侧：Target Price + Consensus Rating + 收藏 -->
        <div class="rating-stock-quote__right">
            <div class="rating-stock-quote__data-item">
                <span class="rating-stock-quote__data-value">{{ formatNumber(targetPrice) }}</span>
                <span class="rating-stock-quote__data-label">{{ $t('target_price') }}</span>
            </div>
            <ConsensusRating :rating="consensusRating" :language-id="languageId" />
            <FavoriteButton :count="favoriteCount" :active="isFavorite" :show-count="showCount" @click.stop.prevent="handleFavoriteClick" />
        </div>
    </div>
</template>

<script >
import ConsensusRating from '../../assets/uis/ConsensusRating.vue';
import FavoriteButton from '../../assets/uis/FavoriteButton.vue';
import PriceChange from '../../assets/uis/PriceChange.vue';
import StockLogo from '../../assets/uis/StockLogo.vue';
import { UP_DOWN_COLOR } from '../../common/enum';
import { LanguageId, useI18n } from '../../common/useI18n';
const __sfc_main = {};
__sfc_main.props = {
  logo: {
    type: String,
    default: ''
  },
  market: {
    type: String,
    default: 'US'
  },
  name: {
    type: String,
    default: ''
  },
  price: {
    type: Number,
    default: 0
  },
  change: {
    type: Number,
    default: 0
  },
  targetPrice: {
    type: Number,
    default: 0
  },
  consensusRating: {
    type: String,
    default: 'Buy'
  },
  favoriteCount: {
    type: Number,
    default: 0
  },
  isFavorite: {
    type: Boolean,
    default: false
  },
  showCount: {
    type: Boolean,
    default: true
  },
  languageId: {
    type: Number,
    default: LanguageId.EN
  },
  upDownColor: {
    type: Number,
    default: UP_DOWN_COLOR.GREEN_UP
  },
  stockId: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;

  // 多语言
  const $t = useI18n(props.languageId);
  const formatNumber = num => {
    return num.toFixed(2);
  };

  // 点击自选按钮
  const handleFavoriteClick = $event => {
    emit('toggle-favorite', $event);
  };
  return {
    $t,
    formatNumber,
    handleFavoriteClick
  };
};
__sfc_main.components = Object.assign({
  StockLogo,
  PriceChange,
  ConsensusRating,
  FavoriteButton
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.rating-stock-quote {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__left {
        display: flex;
        align-items: center;
        gap: 0.1rem;
    }

    &__logo {
        width: 0.65rem;
        height: 0.65rem;
        border-radius: 0.325rem;
        overflow: hidden;
        background: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__logo-placeholder {
        font-size: 0.36rem;
        font-weight: 600;
        color: #999;
    }

    &__info {
        display: flex;
        flex-direction: column;
    }

    &__name {
        height: 0.4rem;
        display: flex;
        align-items: center;
        gap: 0.05rem;
    }

    &__market {
        height: 0.26rem;
        padding: 0 0.048rem;
        border-radius: 0.048rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.2rem;
        font-weight: 400;
        color: #fff;
        line-height: 100%;
        background-color: #00a4ff;
    }

    &__symbol {
        font-size: 0.3rem;
        font-weight: 600;
        color: #333;
        line-height: 100%;
    }

    &__right {
        display: flex;
        align-items: center;
        margin-left: 0.3rem;
        flex: 1;
        justify-content: space-between;
    }

    &__data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.04rem;
    }

    &__data-value {
        font-size: 0.3rem;
        font-weight: 600;
        color: #333;
        line-height: 0.4rem;
        letter-spacing: -0.02rem;
    }

    &__data-label {
        font-size: 0.22rem;
        color: #626262;
        line-height: 0.3rem;
        letter-spacing: -0.01rem;
    }
}
</style>
